import React, { useState, useEffect } from 'react';
import SessionManager from "../../routes/SessionManager";
import Loading from '../Loading';
import bootbox from 'bootbox';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

const BIMModels = () => {

    let sessionManager = new SessionManager();
    let user1 = sessionManager.readCookie('user');

    const user = user1
    const [bim_models, setBimModels] = useState(null);
    const [isProcoreUser, setIsProcoreUser] = useState(true);
    const [procoreUser, setProcoreUser] = useState(null);

    let hasProcoreAccess = (site_id) => {
        CommonUtils.ajax(
            {
                url: API.BASE_URL_PROCORE + '/user/' + site_id,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                }
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    console.log('Procore access ' + JSON.stringify(res.data));
                    setProcoreUser(res.data && res.data.length > 0 ? res.data[0] : null);
                    fetchBIMModels();
                    setIsProcoreUser(true);
                } else {
                    setIsProcoreUser(false);
                    setBimModels([]);
                }
            },
            (res) => {
                setIsProcoreUser(false);
                setBimModels([]);
            });
    }

    useEffect(() => {
        hasProcoreAccess(user1.site_selected.site_id);
    }, []);

    let goToProcore = (forceSignIn = false) => {
        console.log('forceSignIn ' + JSON.stringify(forceSignIn));
        window.location = "https://login.procore.com/oauth/authorize?client_id=3e1ca11c1bea250d7b79c5f3ff6c759b8b606643b1a95460e102267354310e2a&response_type=code&redirect_uri=" + window.location.host + "/settings?site_id=" + user.site_selected.site_id + (forceSignIn ? 'I' : '');
    }

    let refreshTokenAtSiteLevel = () => {
        let site_id = user.site_selected.site_id;
        if (site_id === '8814987278636' || site_id === '1573455425723') {
            site_id = '7777963129656';
        }

        CommonUtils.ajax(
            {
                url: API.BASE_URL_BIM + '/refresh-token-by-site-id/' + site_id,
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.errors) {
                        setBimModels([]);
                        bootbox.confirm('Procore Access token expired and needs re-authentication to fetch image folders. Would you like to re-authenticate ?', (isYes) => {
                            if (isYes)
                                goToProcore(true);
                        });
                    } else {
                        fetchBIMModels();
                    }
                } else {
                    setBimModels([]);
                }
            },
            (res) => {

            });
    }

    let fetchBIMModels = () => {
        CommonUtils.ajax(
            {
                url: API.BASE_URL_BIM + '/bim-models',
                type: 'GET',
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    if (res.data.errors) {
                        refreshTokenAtSiteLevel();
                        // this.setState({ bim_models: [] }, () => {
                        //     bootbox.confirm('Procore Access token expired and needs re-authentication to fetch image folders. Would you like to re-authenticate ?', (isYes) => {
                        //         if (isYes)
                        //             this.goToProcore(true);
                        //     });
                        // });
                    } else {
                        setBimModels(res.data);
                    }
                } else {
                    setBimModels([]);
                }
            },
            (res) => {

            });
    }

    let onBIMModelClick = (model) => {
        var sessionMgr = new SessionManager();
        var user = sessionMgr.readCookie('user');
        user.bim_selected = model;
        user.procore_user = procoreUser;
        sessionManager.storeCookie('user', user);
        window.location = './bim-viewer';
    }

    return (
        <React.Fragment>
            <div className="page-container">
                <div className="row mb-4 px-0">
                    {(isProcoreUser === undefined || bim_models === null) && <Loading>Loading ...</Loading>}

                    {isProcoreUser !== undefined && !isProcoreUser ?
                        <span className="bg-white border-rounded px-2 py-1"><i className="fa fa-exclamation-triangle text-warning"></i> <b className="text-primary">{user.site_selected.site_name}</b> is not connected to a Procore account. <br /><i className="fa fa-exclamation-triangle text-white"></i> Navigate to <a href="./site-management#app-connectors">App Connectors</a> to setup the connectivity.</span>
                        :
                        bim_models && (!Array.isArray(bim_models) || bim_models.length === 0) && <span className="bg-white border-rounded px-2 py-1"><i className="fa fa-exclamation-triangle text-warning"></i> No BIM models found.</span>
                    }

                    {bim_models && Array.isArray(bim_models) && bim_models.map((model, i) => (
                        <div className="card m-2 bg-shadow" key={"bim_model_" + i}>
                            <div className="card-body p-0">
                            </div>
                            <div className="card-header text-app bg-white">
                                <b className="font-weight-700">{model.title}</b>
                                <div className="text-dark">
                                    <span className="font-size-12 font-weight-300">
                                        Created Date: {model.created_at}
                                    </span>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button className="btn btn-sm btn-primary pull-right font-size-12" onClick={() => onBIMModelClick(model)}>
                                    View Model
                                </button>
                            </div>
                        </div>
                    ))}
                    <div id='procore-bim-main' style={{ width: '100%', height: '500px' }}></div>
                </div>
            </div>
        </React.Fragment >
    )
}

export default BIMModels;